// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"83d39533","150":"fe0e6a34","193":"8c0ccf4f","455":"76abb6a4","496":"56a9a4aa","506":"28411032","534":"c2d1a088","536":"e3bb26ac","557":"21121ef6","811":"f5260372","878":"253a0324","885":"fc9c31ce","958":"fc124649","977":"86d65106"}[chunkId] + ".chunk.js";
};